import { apiEndpointBaseUrl } from "@/data-access/core/constants";

/** POST URL for report-engine generate-layout. */
export const templateStudioGenerateLayoutUrl =
  import.meta.env.VITE_TEMPLATE_STUDIO_GENERATE_LAYOUT_URL?.trim() ||
  import.meta.env.VITE_LAYOUT_STUDIO_GENERATE_LAYOUT_URL?.trim() ||
  `${apiEndpointBaseUrl}/report-engine/generate-layout`;
